import { render, staticRenderFns } from "./GuiasList.vue?vue&type=template&id=88c6fd94"
import script from "./GuiasList.vue?vue&type=script&lang=js"
export * from "./GuiasList.vue?vue&type=script&lang=js"
import style0 from "./GuiasList.vue?vue&type=style&index=0&id=88c6fd94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports